import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Sparkles } from "lucide-react";
import api, { API } from "@/lib/api";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const { data } = await api.get("/gallery");
        setItems(data.items);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div data-testid="gallery-page" className="pb-24">
      <div className="mx-auto max-w-3xl px-5 pt-20 text-center lg:px-8">
        <p className="text-sm font-semibold uppercase tracking-wider text-primary">Before &amp; After</p>
        <h1 className="mt-3 font-heading text-4xl font-extrabold tracking-tighter md:text-5xl">See the difference</h1>
        <p className="mt-5 text-lg text-muted-foreground">Real bins we've renewed across Southern Maryland. Grime in, sparkle out.</p>
      </div>

      <div className="mx-auto mt-14 max-w-6xl px-5 lg:px-8">
        {loading ? (
          <p className="py-16 text-center text-muted-foreground">Loading gallery…</p>
        ) : items.length === 0 ? (
          <div className="rounded-2xl border border-dashed border-border py-20 text-center">
            <Sparkles className="mx-auto h-10 w-10 text-primary" />
            <p className="mt-4 font-heading text-lg font-bold">Fresh photos coming soon</p>
            <p className="mt-1 text-muted-foreground">We're snapping our best before-and-afters. Check back shortly!</p>
          </div>
        ) : (
          <div className="grid gap-6 md:grid-cols-2">
            {items.map((it) => (
              <div key={it.id} data-testid={`gallery-item-${it.id}`} className="overflow-hidden rounded-2xl border border-border bg-card">
                <div className="grid grid-cols-2">
                  <figure className="relative">
                    <img src={`${API}/gallery/image/${it.id}/before`} alt="Before" className="h-56 w-full object-cover" />
                    <figcaption className="absolute left-2 top-2 rounded-full bg-black/60 px-2.5 py-1 text-xs font-bold text-white">Before</figcaption>
                  </figure>
                  <figure className="relative">
                    <img src={`${API}/gallery/image/${it.id}/after`} alt="After" className="h-56 w-full object-cover" />
                    <figcaption className="absolute left-2 top-2 rounded-full bg-primary px-2.5 py-1 text-xs font-bold text-primary-foreground">After</figcaption>
                  </figure>
                </div>
                {it.caption && <p className="px-5 py-4 text-sm font-semibold">{it.caption}</p>}
              </div>
            ))}
          </div>
        )}

        <div className="mt-16 rounded-2xl bg-gradient-to-br from-primary via-primary/80 to-[#0D1B2A] px-8 py-12 text-center ring-1 ring-secondary/30">
          <h3 className="font-heading text-2xl font-bold text-white">Want bins this clean?</h3>
          <Link to="/booking" className="mt-6 inline-flex items-center gap-2 rounded-xl bg-secondary px-7 py-3.5 font-extrabold text-secondary-foreground shadow-[0_0_20px_rgba(57,255,20,0.3)] transition-all hover:-translate-y-0.5 hover:brightness-110">
            Book Now <ArrowRight className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </div>
  );
}
